export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";
export const ENV_NAME = process.env.REACT_APP_ENV_NAME || "test";
export const ENCRYPTION_KEY =
    process.env.REACT_APP_ENCRYPTION_KEY || "myencryptionkey";
export const DISDETTA_MIN_DAYS = 60;
export const PER_PAGE_MAX_LIMIT = 20000;
export const RECAPTCHA_SITE_KEY = "6LdcTJMUAAAAALS7n9jHEAMBn17vcXLRgWp6GWFh";
export const HELK_DASHBOARD_CLUSTER_SYSTEM =
    "15850497-5e76-552d-bbde-002cd5223e30";
export const HELK_DASHBOARD_CLUSTER_DOCKER =
    "9a951a7c-61d2-5c03-a106-759270c56637";
export const HELK_DASHBOARD_CUSTOMER_OVERVIEW =
    "41a4233b-e0c4-5be4-b3fd-622909f533e2";
export const HELK_DASHBOARD_CUSTOMER_START =
    "c04dab4f-12f6-51b8-84d6-51c886f42371";
export const HELK_DASHBOARD_SYSERR = "275d80f7-2d06-539b-81ee-2bac7000a32d";



// WEBPACK FOOTER //
// ./src/config.js